import { InputCurrencyGroup } from "@finanedi.es/storybook"
import { useMemo } from "react"
import { UseFormSetValue, UseFormWatch } from "react-hook-form"
import { useTranslation } from "react-i18next"
import {
  FieldTemplateOne,
  renderFieldTemplateOne,
} from "../../PlantillasBloquesTabla"

const VolumenDeOperaciones = ({
  setValue,
  watch,
}: {
  setValue: UseFormSetValue<$TSMigrationFixMe>
  watch: UseFormWatch<$TSMigrationFixMe>
}) => {
  const { t } = useTranslation()
  const values = watch()
  const fields: FieldTemplateOne[] = [
    {
      label: t("taxSummary.declaracion.resultadoFinal.box21"),
      code: "casilla99",
      inputNumber: "99",
      value: values?.casilla99,
    },
    {
      label: t("taxSummary.declaracion.resultadoFinal.box22"),
      code: "casilla653",
      inputNumber: "653",
      value: values?.casilla653,
      disabled: true,
    },
    {
      label: t("modelo390.volumen.entregasIntracom"),
      code: "casilla103",
      inputNumber: "103",
      value: values?.casilla103,
    },
    {
      label: t("taxSummary.declaracion.resultadoFinal.box24"),
      code: "casilla104",
      inputNumber: "104",
      value: values?.casilla104,
    },
    {
      label: t("modelo390.volumen.exentasSinDerecho"),
      code: "casilla105",
      inputNumber: "105",
      value: values?.casilla105,
    },
    {
      label: t("taxSummary.declaracion.volumenOperaciones.box1"),
      code: "casilla110",
      inputNumber: "110",
      value: values?.casilla110,
    },
    {
      label: t("taxSummary.declaracion.adicionalInfo.box4"),
      code: "casilla125",
      inputNumber: "125",
      value: values?.casilla125,
    },
    {
      label: t("taxSummary.declaracion.adicionalInfo.box5"),
      code: "casilla126",
      inputNumber: "126",
      value: values?.casilla126,
    },
    {
      label: t("taxSummary.declaracion.adicionalInfo.box6"),
      code: "casilla127",
      inputNumber: "127",
      value: values?.casilla127,
    },
    {
      label: t("taxSummary.declaracion.volumenOperaciones.box2"),
      code: "casilla128",
      inputNumber: "128",
      value: values?.casilla128,
    },
    {
      label: t("taxSummary.declaracion.resultadoFinal.box28"),
      code: "casilla100",
      inputNumber: "100",
      value: values?.casilla100,
    },
    {
      label: t("taxSummary.declaracion.resultadoFinal.box29"),
      code: "casilla101",
      inputNumber: "101",
      value: values?.casilla101,
    },
    {
      label: t("taxSummary.declaracion.resultadoFinal.box30"),
      code: "casilla102",
      inputNumber: "102",
      value: values?.casilla102,
    },
    {
      label: t("taxSummary.declaracion.resultadoFinal.box31"),
      code: "casilla227",
      inputNumber: "227",
      value: values?.casilla227,
    },
    {
      label: t("taxSummary.declaracion.resultadoFinal.box32"),
      code: "casilla228",
      inputNumber: "228",
      value: values?.casilla228,
    },
    {
      label: t("taxSummary.declaracion.volumenOperaciones.box3"),
      code: "casilla106",
      inputNumber: "106",
      value: values?.casilla106,
    },
    {
      label: t("modelo390.volumen.bienesInversionEntregas"),
      code: "casilla107",
      inputNumber: "107",
      value: values?.casilla107,
    },
  ]

  const casilla108 = useMemo(() => {
    const casilla99 = values?.casilla99 ? Number(values?.casilla99) : 0
    const casilla653 = values?.casilla653 ? Number(values?.casilla653) : 0
    const casilla103 = values?.casilla103 ? Number(values?.casilla103) : 0
    const casilla104 = values?.casilla104 ? Number(values?.casilla104) : 0
    const casilla105 = values?.casilla105 ? Number(values?.casilla105) : 0
    const casilla110 = values?.casilla110 ? Number(values?.casilla110) : 0
    const casilla100 = values?.casilla100 ? Number(values?.casilla100) : 0
    const casilla101 = values?.casilla101 ? Number(values?.casilla101) : 0
    const casilla102 = values?.casilla102 ? Number(values?.casilla102) : 0
    const casilla125 = values?.casilla125 ? Number(values?.casilla125) : 0
    const casilla126 = values?.casilla126 ? Number(values?.casilla126) : 0
    const casilla127 = values?.casilla127 ? Number(values?.casilla127) : 0
    const casilla128 = values?.casilla128 ? Number(values?.casilla128) : 0
    const casilla228 = values?.casilla228 ? Number(values?.casilla228) : 0
    const casilla227 = values?.casilla227 ? Number(values?.casilla227) : 0
    const casilla106 = values?.casilla106 ? Number(values?.casilla106) : 0
    const casilla107 = values?.casilla107 ? Number(values?.casilla107) : 0
    const result =
      casilla99 +
      casilla653 +
      casilla103 +
      casilla104 +
      casilla105 +
      casilla110 +
      casilla100 +
      casilla101 +
      casilla102 +
      casilla125 +
      casilla126 +
      casilla127 +
      casilla128 +
      casilla227 +
      casilla228 -
      casilla106 -
      casilla107
    setValue("casilla108", result)
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values?.casilla99,
    values?.casilla653,
    values?.casilla103,
    values?.casilla104,
    values?.casilla105,
    values?.casilla110,
    values?.casilla100,
    values?.casilla101,
    values?.casilla102,
    values?.casilla125,
    values?.casilla126,
    values?.casilla127,
    values?.casilla128,
    values?.casilla228,
    values?.casilla227,
    values?.casilla106,
    values?.casilla107,
  ])

  return (
    <div
      title='VolumenOperacion'
      className='tw-w-full tw-px-6 tw-pb-6'
    >
      <div className='tw-flex tw-flex-col'>
        <p className='tw-font-medium tw-text-sm'>
          {t("taxSummary.declaracion.operacionesEspecificas.text1")}
        </p>
        {fields.map((field) => renderFieldTemplateOne(field, setValue))}
        <div className='tw-grid tw-grid-cols-5 tw-items-center tw-gap-2 tw-border-b tw-border-gray-200 tw-py-3'>
          <p className='tw-col-span-4 tw-text-sm tw-font-medium'>
            {t("taxSummary.declaracion.volumenOperaciones.text1")}
          </p>
          <div className='tw-col-span-1'>
            <InputCurrencyGroup
              suffix='€'
              placeholder='0,00'
              className='tw-w-full tw-h-full tw-text-sm'
              numberGroup='108'
              value={casilla108}
              disabled
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default VolumenDeOperaciones
